export default __webpack_public_path__ + "assets/apple-touch-icon-167x167-c0cef26.png";